export const SpreadToZoomIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="66" height="60" viewBox="0 0 66 60" fill="none">
    <mask
      id="mask0_444_207"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="66"
      height="51"
    >
      <path
        d="M30.5043 46.1164L30.3642 45.9452C30.1256 45.6535 29.9674 45.3044 29.9054 44.9327C29.6907 43.6445 30.6596 42.462 31.9649 42.4192L56.9017 41.6016C58.5962 41.546 60 42.9046 60 44.6V45.25C60 46.7688 61.2312 48 62.75 48C64.2688 48 65.5 46.7688 65.5 45.25V3C65.5 1.34315 64.1569 0 62.5 0H18H3C1.34315 0 0 1.34315 0 3V32.5L0.421109 48.0811C0.46502 49.7057 1.79473 51 3.42001 51H22H28.19C30.7126 51 32.1017 48.0687 30.5043 46.1164Z"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_444_207)">
      <rect
        x="64.3892"
        y="1.86957"
        width="47.0167"
        height="62.019"
        rx="11.7725"
        transform="rotate(90 64.3892 1.86957)"
        stroke="#B9BCCB"
        strokeWidth="1.7411"
      />
      <path
        d="M15.5409 36.9843L11.3112 37.3097C10.9891 37.3344 10.7208 37.0661 10.7456 36.744L11.0709 32.5143"
        stroke="#FFB4C9"
        strokeWidth="1.7411"
        strokeLinecap="round"
      />
      <path d="M17.9456 30.3223L12.1884 35.8675" stroke="#FFB4C9" strokeWidth="1.7411" strokeLinecap="round" />
      <path
        d="M34.0701 10.5704L38.2998 10.245C38.6219 10.2202 38.8902 10.4886 38.8654 10.8107L38.5401 15.0404"
        stroke="#FFB4C9"
        strokeWidth="1.7411"
        strokeLinecap="round"
      />
      <path d="M31.6648 17.2324L37.422 11.6871" stroke="#FFB4C9" strokeWidth="1.7411" strokeLinecap="round" />
    </g>
    <path
      d="M36.1037 42.6309L35.3616 24.6929C35.3268 23.8533 35.6124 23.035 36.1554 22.4178C36.6984 21.8007 37.4544 21.4353 38.2571 21.4021C39.0597 21.3689 39.8433 21.6706 40.4355 22.2407C41.0276 22.8109 41.3798 23.6029 41.4145 24.4424L42.0694 40.2701"
      stroke="#848199"
      strokeWidth="1.7411"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M47.8074 35.7722C47.8074 34.9689 48.1266 34.1984 48.6946 33.6304C49.2627 33.0623 50.0332 32.7432 50.8365 32.7432C51.6399 32.7432 52.4103 33.0623 52.9784 33.6304C53.5464 34.1984 53.8656 34.9689 53.8656 35.7722V38.8013"
      stroke="#848199"
      strokeWidth="1.7411"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M41.7764 34.2068C41.7764 33.4034 42.0956 32.633 42.6636 32.0649C43.2317 31.4969 44.0021 31.1777 44.8055 31.1777C45.6089 31.1777 46.3793 31.4969 46.9474 32.0649C47.5154 32.633 47.8346 33.4034 47.8346 34.2068V37.2359"
      stroke="#848199"
      strokeWidth="1.7411"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M53.866 37.7918C53.866 36.9884 54.1851 36.2179 54.7532 35.6499C55.3212 35.0818 56.0917 34.7627 56.895 34.7627C57.6984 34.7627 58.4688 35.0818 59.0369 35.6499C59.605 36.2179 59.9241 36.9884 59.9241 37.7918V46.879C59.9241 50.0924 58.6476 53.1742 56.3753 55.4464C54.1031 57.7187 51.0213 58.9952 47.8078 58.9952H43.7691H44.1891C42.1825 58.9955 40.2073 58.4975 38.4407 57.5459C36.6742 56.5942 35.1716 55.2187 34.068 53.5429L33.6722 52.9371C33.0422 51.9698 30.5172 48.008 24.7136 41.3695C24.3268 40.682 24.2234 39.8707 24.4256 39.1081C24.6277 38.3456 25.1194 37.692 25.796 37.2863C26.5166 36.8539 27.3611 36.6747 28.1953 36.7772C29.0295 36.8796 29.8055 37.2578 30.4001 37.8518L35.7405 42.7847"
      stroke="#848199"
      strokeWidth="1.7411"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
